import { FC, Fragment } from "react";
import { Stack, Typography } from "@mui/material";
import { SavingsOpportunity } from "@/services/cloudchipr.api";
import { ResourceDetailsOpportunityRowContentTable } from "@/components/pages/common/resource-details/components/content/opportunities-content/components/row-content/ResourceDetailsOpportunityRowContentTable";
import { ResourceDetailsMetricsTabContent } from "@/components/pages/common/resource-details/components/content/metrics-content/ResourceDetailsMetricsTabContent";
import { ResourceDetailsOpportunityOffHoursContent } from "@/components/pages/common/resource-details/components/content/opportunities-content/components/row-content/ResourceDetailsOpportunityOffHoursContent";
import { useAppSelector } from "@/store/hooks";
import { resourceDetailsTargetResourceTypeSelector } from "@/store/resource-details/selectors/target-resource/resourceDetailsTargetResourceTypeSelector";
import { metricAvailableResourceTypes } from "@/components/pages/common/resource-details/utils/constants/metrics";

interface ResourceDetailsOpportunityRowContentProps {
  opportunity: SavingsOpportunity;
}

export const ResourceDetailsOpportunityRowContent: FC<
  ResourceDetailsOpportunityRowContentProps
> = ({ opportunity }) => {
  const resourceType = useAppSelector(
    resourceDetailsTargetResourceTypeSelector,
  );
  const showMetrics =
    resourceType && metricAvailableResourceTypes.has(resourceType);

  return (
    <Stack spacing={1}>
      <ResourceDetailsOpportunityRowContentTable opportunity={opportunity} />

      {opportunity.action_type === "off_hours" &&
        opportunity.recommendation_id && (
          <ResourceDetailsOpportunityOffHoursContent
            recommendationId={opportunity.recommendation_id}
          />
        )}

      {showMetrics && (
        <Fragment>
          <Typography variant="subtitle2">Metrics</Typography>
          <ResourceDetailsMetricsTabContent />
        </Fragment>
      )}
    </Stack>
  );
};
